import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=3e4fffc5"
import script from "./Detail.ts?vue&type=script&lang=ts&external"
export * from "./Detail.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports